import RailsNestedForm from '@stimulus-components/rails-nested-form'

export default class extends RailsNestedForm { }
